import React, { useEffect, useRef, useState } from "react";
import {
  Navbar,
  Hero,
  About,
  Projects,
  Services,
  Contact,
  Footer,
  Profile,
  Sidebar,
  Experience,
} from "./components";
import "./App.css";
import "./components/modern-footer-sidebar.css";
import { AnimatePresence } from "framer-motion";
import "fontsource-roboto";
import Aos from "aos";
import "aos/dist/aos.css";

import { Switch, Route, useLocation } from "react-router-dom";

function App() {
  const location = useLocation();
  const scrollPendingRef = useRef(false);

  const [click, setClick] = useState(false);
  const [value, setValue] = useState(true);
  const [color, setColor] = useState(true);
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem("portfolio-theme");
    const initialTheme = savedTheme || "dark";
    // Apply theme immediately before render to prevent flash
    document.documentElement.setAttribute("data-theme", initialTheme);
    return initialTheme;
  });

  // Save theme to localStorage when it changes
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("portfolio-theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === "dark" ? "light" : "dark"));
  };

  useEffect(() => {
    Aos.init({
      duration: 700,
      easing: "ease-out-cubic",
      once: true,
      offset: 80,
    });
  }, []);

  useEffect(() => {
    Aos.refresh();
  }, [location.pathname]);

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    scrollPendingRef.current = true;
  }, [location.key]);

  return (
    <>
      <Navbar
        click={click}
        value={value}
        setClick={setClick}
        setValue={setValue}
        color={color}
        setColor={setColor}
        theme={theme}
        toggleTheme={toggleTheme}
      />
      <Sidebar
        click={click}
        value={value}
        setClick={setClick}
        setValue={setValue}
      />
      <AnimatePresence
        exitBeforeEnter
        initial={false}
        onExitComplete={() => {
          if (scrollPendingRef.current) {
            window.scrollTo({ top: 0, left: 0, behavior: "auto" });
            scrollPendingRef.current = false;
          }
        }}
      >
        <Switch location={location} key={location.key}>
          <Route exact path="/" component={Hero} />
          <Route path="/about" component={About} />
          <Route path="/projects">
            <Projects />
          </Route>
          <Route path="/services" component={Services} />
          <Route path="/contact" component={Contact} />
          <Route path="/education" component={Profile} />
          <Route path="/experience" component={Experience} />
        </Switch>
      </AnimatePresence>

      <Footer />
    </>
  );
}

export default App;
